import {Component, ElementRef, HostListener, OnChanges, OnInit, ViewChild} from '@angular/core';
import {NoticesService} from '../../../services/notices.service';
import {UrlService} from '../../../services/url.service';
import {Notice} from '../../../types/data.types';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'playlist-and-notices-list',
    templateUrl: './playlist-and-notices-list.component.html',
    styleUrls: ['./playlist-and-notices-list.component.scss']
})
export class PlaylistAndNoticesListComponent implements OnInit, OnChanges {
    currentNotice: Notice;
    showModal = false;
    showFilter: false;
    action = 'playlist';
    search = {playlist: '', notice: ''};
    filtered = {
        status:{active: true, expired: true, future: true, archived: false},
        category:[]
    };
    categoriesList: Array<any> = [];
    newTheme = false;
    orientation = 'horizontal';
    currentDate = new Date();
    currentWeather = {
        icon: 'am_showers.png',
        temp: ''
    };
    currentPlaylist = {};
    template = '';
    buildingName = '';
    contentHtml = '';
    @ViewChild('display') display: ElementRef;
    @ViewChild('displayScreen') displayScreen: ElementRef;

    constructor(
        public urlService: UrlService,
        public noticesService: NoticesService
    ) {}

    ngOnInit() {
        this.initData();
        this.scalingScreen('', '');
        setTimeout( () => this.showModal = true, 300);
        setInterval(() => this.updateClock(), 1000);
    }

    initData() {

    }

    orderBy(orderBy: string, $event) {
        if (this.noticesService.data.allNotices.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    setCurrentNotice(item): void {
        this.template = item.content;
        this.currentNotice = item;
    }

    restoreItem(item): void {

    }

    deleteItem(item): void {

    }

    getCategoryNameById(id): string {
        return '';
    }

    setPlaylist(item): void {
        // TEMPORARILY COMMENTED OUT TWO LINES BELOW
        // this.currentPlaylist = item;
        // this.buildingName = item.title;
        this.action = 'notices';
    }

    showNoticesByPlaylist(item): void {
        this.setPlaylist(item);
        // this.promiseNotices = NoticeFactory.getNoticesByPlaylistId(this.currentPlaylist.id).then(function(response){
        //     if(response.data.hasOwnProperty('response')) {
        //         this.listNotices = response.data.response;
        //     } else {
        //         $notification.notify.error('Notices not found!');
        //     }
        // });
    }

    updateScrollHeight(): void {
        setTimeout(function() {
            this.display.find('[ss-container]').slimscroll();
        });
    }

    scalingScreen(newVal, oldVal): void {
        if (newVal != oldVal) {
        }
        this.display.nativeElement.style.opacity = '0';
        setTimeout(function() {
            if(this.display) {
                var display = this.display;
                var displayTemplate = this.displayScreen;
                var zoom = Math.min(
                    (display.offsetWidth ) / displayTemplate.offsetWidth,
                    (display.offsetHeight) / displayTemplate.offsetHeight
                );
                this.displayScreen.style.transform = 'scale(' + zoom + ') translateX(-50%)';
                this.displayScreen.style.transformOrigin = 'left top';
                this.displayScreen.style.position = 'absolute';
                this.displayScreen.style.left = '50%';
                this.displayScreen.style.top = '0';
                }
                    // this.updateScrollHeight();
            $('#display').clearQueue().stop().animate({
                        opacity: 1
                    }, 1000, function() {

                    });
        }, 500);
    }

    // changeWeather(): void {
    //     if (this.buildings[this.building] && Object.keys(this.buildings[this.building].hourly).length) {
    //         this.weatherHourly = this.buildings[this.building].hourly;
    //     } else {
    //         for(var b in this.buildings) {
    //             if(!Object.keys(this.weatherHourly).length && Object.keys(this.buildings[b].hourly).length) {
    //                 this.weatherHourly = this.buildings[b].hourly;
    //             }
    //         }
    //     }
    // }
    //
    updateClock(): void {
        // this.currentTime = new Date();
        this.currentDate = new Date();
        // this.currentDate = this.currentTime.valueOf();
        // let currentHour = this.currentTime.tz("America/Toronto").format('ha');
        // if(currentHour in this.weatherHourly) {
        //     this.currentWeather = this.weatherHourly[currentHour];
        // }
    }


    // $scope.$watch(function () { return this.building;}, changeWeather);

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.scalingScreen('', '');
    }

    // $scope.$watch(function(){return this.template}, function (newVal, oldVal) {
    //     this.setContent(newVal);
    // });
    //
    // setContent(content): void{
    //     this.promiseContent = preLoad(content).then(function(res) {
    //         this.contentHtml = $sce.trustAsHtml(res);
    //         this.updateScrollHeight();
    //     });
    // }

    // preLoad(content): void {
    //     var promises = [];
    //     function loadImage(src) {
    //         return $q(function(resolve, reject) {
    //             setTimeout(function() {
    //                 var image = new Image();
    //                 image.src = src;
    //                 image.onload = function () {
    //                     resolve(image);
    //                 };
    //                 image.onerror = function (e) {
    //                     reject(e);
    //                 };
    //             }, 300);
    //         });
    //     }
    //     angular.element('<div>'+ content + '</div>').find('img').each(function(){
    //         promises.push(loadImage(this.src));
    //     });
    //
    //     return $q.all(promises).then(function () {
    //         return content;
    //     }, function () {
    //         return content;
    //     });
    // }

    ngOnChanges(changes) {
        console.log(changes);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/notices/playlist-and-notices-list/playlist-and-notices-list.component.ts